import { CalendarEvent } from 'angular-calendar';
import * as moment from 'moment';
import { organizationI } from './organization';
import { patientI } from './patient';
import { practitionerI } from './practitioner';
import { procedureI } from './procedure';

export type scheduleType = 'Exame' | 'Consulta';

interface Service {
  coding: {
    code: string;
    display: string;
  }[];
}

interface Actor {
  reference: string;
  code: string;
  display: string;
  type: string;
}

interface PlanningHorizon {
  start: string;
  end: string;
}

export interface Schedule {
  schedule_id: string;
  name: string;
  type: scheduleType;
  scheduling_method?: string;
  status: string;
  specialty?: string;
  servicetype_name?: string;
  servicecategory_name?: string;
  organization: {
    organization_id: string;
    name: string;
  };
  secretary?: {
    name: string;
    secretary_id: string;
  };
  practitioner: {
    name: string;
    practitioner_id: string;
  };
  patient: {
    name: string;
    patient_id: string;
  };
  startDate: string;
  endDate?: string;
  diagnosis?: string;
}

export interface ScheduleAPIResponse {
  schedule_id: string;
  name: string;
  scheduling_method?: string;
  active: boolean;
  type: string;
  serviceCategory: Service[];
  serviceType: Service[];
  specialty: Service[];
  actor: Actor[];
  planningHorizon: PlanningHorizon;
  status: string;
}

/*** TIPAGENS ANTIGAS  */
export interface scheduleI { 
    id?: number | null;
    type: scheduleType;   
    scheduling_method?: string; 
    dateStart: string | moment.Moment;
    dateEnd?: string | moment.Moment;
    date?: string | moment.Moment;
    patient: any;
    practioner?: any;
    procedure?: procedureI;   
    organization?: any;
    status?: string;
    active: boolean;
    practitioner?: any;
    health_plan_name ?: string;
    agreement?: any;
    health_plan_card?: string;
    paymentMethod?: string;
}

export interface openingHourI {
  timeStart: string;
  timeEnd: string;
  dayOfWeek: any;
}

export interface rescheduleI {
  date: any;
  time: string;
}

export interface modalDataI {
  action: string;
  event: CalendarEvent;
}

export interface scheduleStatus {
  id: number | string;
  text: string;
  color: string;
  icon: string;
}
